module.exports = "<div class=\"form-check form-check-inline\" *ngFor=\"let filter of filters\">\n  <park-filter-item (change)=\"setFilter($event)\"\n                         [checked]=\"isFilterChecked(filter.value)\"\n                         [label]=\"filter.label\"\n                         [value]=\"filter.value\">\n  </park-filter-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/filter/park-filter.html
// module id = ./src/app/dashboard/parks/park/filter/park-filter.html
// module chunks = main